import { Dispatch } from 'redux';
import { LoginService } from '../../services/LoginService';
import { Admin_API } from '../../ApiNames';


export const fetchDataSuccess = (data: any) => ({
  type: 'FETCH_DATA_SUCCESS',
  payload: data,
});
export const fetchPieChartDataSuccess = (pieChartData: any, piechartOptions: any) => ({
  type: 'FETCH_PIE_CHART_DATA_SUCCESS',
  payload: { pieChartData, piechartOptions }
});
export const fetchDonorChartDataSuccess = (donorChartData: any, donorrchartOptions: any) => ({
  type: 'FETCH_Donor_CHART_DATA_SUCCESS',
  payload: { donorChartData, donorrchartOptions }
});



export const fetchData = () => {
  return async (dispatch: Dispatch) => {
    try {
      const payload = { q: 1 };
      const apiname = Admin_API.addashboard;
      const response = await LoginService.getData(apiname, payload);
      dispatch(fetchDataSuccess(response));
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
};
export const fetchPieChartData = () => {
  return async (dispatch: Dispatch) => {
    try {
      const payload = { q: 5 };
      const apiname = Admin_API.addashboard;
      const response = await LoginService.getData(apiname, payload);
      if (Array.isArray(response) && response.length > 0) {
        const documentStyle = getComputedStyle(document.documentElement);
        const labels = response.map(item => item.label);
        const values = response.map(item => item.value);
        const data = {
          // labels: ['A', 'B', 'C'],
          labels: labels,
          datasets: [
            {
              // data: response
              data: values
            }
          ]
        }
        const options = {
          plugins: {
            legend: {
              labels: {
                usePointStyle: true
              }
            }
          }
        };
        dispatch(fetchPieChartDataSuccess(data, options));
      }
    } catch (error) {
      console.error('Error fetching chart data:', error);
    }
  };
};
//To get bar chart data
export const fetchDonorChartData = () => {
  return async (dispatch: Dispatch) => {
    try {
      const payload = { q: 6 };
      const apiname = Admin_API.addashboard;
      const response = await LoginService.getData(apiname, payload);
      if (Array.isArray(response) && response.length > 0) {
        const labels = response.map(item => item.label);
        const values = response.map(item => item.value);
        const data = {
          labels: labels,
          datasets: [
            {
              label: 'Members',
              data:
                values
              ,
              backgroundColor: [
                'rgba(255, 159, 64, 0.2)',
                'rgba(75, 192, 192, 0.2)',
                'rgba(54, 162, 235, 0.2)',
                'rgba(153, 102, 255, 0.2)',
              ],
              borderColor: [
                'rgb(255, 159, 64)',
                'rgb(75, 192, 192)',
                'rgb(54, 162, 235)',
                'rgb(153, 102, 255)',
              ],
              borderWidth: 1,
              barThickness: 70,
              maxBarThickness: 80,
              minBarLength: 2
            },
          ],
        };
        const options = {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            y: {
              beginAtZero: true,
            },
          },
        };
        dispatch(fetchDonorChartDataSuccess(data, options));
      }
    } catch (error) {
      console.error('Error fetching chart data:', error);
    }

  };
};



